export default function expandToHashMap(value, keys) {
  return keys.reduce(function (hashMap, key) {
    hashMap[key] = value;
    return hashMap;
  }, {});
}


//////////////////
// WEBPACK FOOTER
// /var/www/clients/client0/web6/deploy/releases/20230327134040/web/app/themes/metadieta/node_modules/@popperjs/core/lib/utils/expandToHashMap.js
// module id = 33
// module chunks = 0